import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { IReportsActions, IThunkGetAiAssistUsageOverviewReport } from '../types';

const onGetAiAssistUsageOverviewReport: IThunkGetAiAssistUsageOverviewReport = thunk(
  async (
    { setAiAssistUsageOverviewReport, setAiAssistUsageReportFilters }: Actions<IReportsActions>,
    { requestInfo, params },
  ) => {
    const aiAssistUsageReport = await api.reports
      .getAiAssistUsageOverviewReport(requestInfo, params)
      .then(r => r.data);

    setAiAssistUsageOverviewReport({
      list: aiAssistUsageReport.items,
      pagination: {
        total: aiAssistUsageReport.total,
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
      },
    });

    setAiAssistUsageReportFilters({
      sorting: params.sorting,
      sortDirection: params.sortDirection,
      userIds: params.userIds,
    });
  },
);

export default onGetAiAssistUsageOverviewReport;
